<template>
    <div class="thanks">
        <ThanksBanner :result="result" />
        <div class="thanks__blocks">
            <div class="thanks__block">
                <ThanksProps :result="result" />
            </div>
            <aside class="thanks__aside">
                <div class="thanks__block">
                    <ThanksBasket :result="result" />
                </div>
                <div class="thanks__block">
                    <ThanksTotal
                        :result="result"
                        :messages="result.order.messages.paymentData"
                    />
                </div>
                <div class="thanks__block">
                    <CheckoutGuarantee/>
                </div>
            </aside>
        </div>
    </div>
</template>

<script setup>
import { useStore } from 'vuex';

import ThanksBanner from "./ThanksBanner";
import ThanksProps from "./ThanksProps";
import ThanksBasket from "./ThanksBasket";
import ThanksTotal from "./ThanksTotal";
import CheckoutGuarantee from "../CheckoutGuarantee/CheckoutGuarantee";

const {
    state: {
        thanks: {
            data: result
        }
    },
} = useStore();

</script>

<script>
export default {
    name: 'Thanks',
}
</script>

<style lang="scss" scoped>
.thanks{
    margin-bottom: 56px;
    @include point-md{
        margin-bottom: 80px;
    }
    &__blocks{
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 4px;
        align-items: flex-start;
        @include point-lg{
            grid-template-columns: 1fr 444px;
        }
    }
    &__block{
        background-color: #fff;
        padding: 20px 16px;
        @include point-md{
            padding: 32px 24px;
        }
        @include point-lg{
            padding: 24px;
        }
    }
    &__aside{
        display: grid;
        grid-row-gap: 4px;
    }
}
</style>